import React, { useRef } from "react";
import getClasses from "../../../utils/getClasses";
import { UseFormRegisterReturn } from "react-hook-form";

export interface FormInputProps {
  label: string;
  placeholder: string;
  type?: "text" | "email" | "password" | "number";
  isInvalid?: boolean;
  wrapperClass?: string;
  required?: boolean;
  defaultValue?: string;
  typeErrors?: string;
  disabled?: boolean;
  register?: UseFormRegisterReturn;
}
const FormInput = (props: FormInputProps) => {
  const {
    label,
    placeholder,
    defaultValue,
    type = "text",
    isInvalid = false,
    wrapperClass = "col-lg-4",
    typeErrors = "",
    register,
    required,
    disabled,
  } = props;
  //const ref = useRef<HTMLInputElement>(null);
  return (
    <div className={wrapperClass}>
      <div
        className={`form-group offset-lg-0 mt-1 ${getClasses({
          error: isInvalid,
        })}`}
      >
        <label
          htmlFor={label}
          className={`form-control-label ${getClasses({
            "title-red": isInvalid,
          })}`}
        >
          {label} {required && "*"}
        </label>
        <input
          disabled={disabled}
          defaultValue={defaultValue}
          placeholder={placeholder}
          type={type}
          className={`form-control  p-md ${isInvalid ? "is-invalid" : ""}`}
          {...register}
        />
        {typeErrors && (
          <p
            className={`form-control-label  ${getClasses({
              "title-red": isInvalid,
            })}`}
          >
            <i className="icon-icons-system-notification-info message-icon"></i>
            {typeErrors}
          </p>
        )}
      </div>
    </div>
  );
};

export default FormInput;
